import { Box, TextField } from "@mui/material";

// Name, phone and email inside the "עדכון איש קשר" dialog
const ContactChangeFields = ({
  contactNameChangeRequest,
  contactPhoneChangeRequest,
  contactEmailChangeRequest,
  contactFieldErrors,
  contactEmailErrorMessage,
  handleContactNameChangeInput,
  handleContactPhoneChangeInput,
  handleContactEmailChangeInput,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <TextField
      autoFocus
      required
      fullWidth
      label="שם איש קשר"
      value={contactNameChangeRequest}
      onChange={handleContactNameChangeInput}
      error={!!contactFieldErrors.contactName}
      helperText={contactFieldErrors.contactName}
      variant="outlined"
    />
    <TextField
      required
      fullWidth
      label="טלפון"
      value={contactPhoneChangeRequest}
      onChange={handleContactPhoneChangeInput}
      inputProps={{ inputMode: "numeric" }}
      error={!!contactFieldErrors.contactPhone}
      helperText={contactFieldErrors.contactPhone}
      variant="outlined"
    />
    <TextField
      required
      fullWidth
      label="אימייל"
      value={contactEmailChangeRequest}
      onChange={handleContactEmailChangeInput}
      error={!!contactEmailErrorMessage}
      helperText={contactEmailErrorMessage}
      variant="outlined"
    />
  </Box>
);

export default ContactChangeFields;
